import confirm from './confirm';
import OriginModal from './Modal';
var Modal = OriginModal;

Modal.alarm = function (props) {
  var config = Object.assign({
    showCancel: false
  }, props);
  return confirm(config);
};

Modal.confirm = function (props) {
  var config = Object.assign({}, props);
  return confirm(config);
};

export default Modal;